import { useCallback, useEffect, useState } from "react";
import type { Grinder } from "../types";
import { api } from "../lib/api";

export function useGrinders() {
  const [data, setData] = useState<Grinder[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(() => {
    setError(null);
    api.grinders.list().then(setData).catch((e: Error) => setError(e.message));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, error, refresh };
}
